import { render } from "./Settings.vue?vue&type=template&id=b11e5a00&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=b11e5a00&scoped=true&lang=css"
import "./Settings.vue?vue&type=style&index=1&id=b11e5a00&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b11e5a00"]])

export default __exports__